import { useEffect, useState, useRef } from 'react';
import { useNavigate, Link} from 'react-router-dom';
import { UserAuth } from './context/AuthContext';
import { motion } from "framer-motion";
import bgPattern from "./background_pattern.png";
import ZigzagIcons from "./ZigzagIcons";
import icon0 from "./step00.jpg";
import icon1 from "./step01.jpg";
import icon2 from "./step02.jpg";
import icon3 from "./step03.jpg";
import icon4 from "./step04.jpg";
import icon5 from "./step05.jpg";
import icon6 from "./step06.jpg";

function LandingPage() {
    const [showModal, setShowModal] = useState(false);
    const { signIn } = UserAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const {user} = UserAuth();
    const [errorMessage, setErrorMessage] = useState('');
    const [emailForShow, setEmailForShow] = useState("");
    const [lang, setLang] = useState("en");
    const [activeVideoIndex, setActiveVideoIndex] = useState(0);
    const videos = [
        {
            title: {
                ru: "Учим слова",
                en: "Learning words",
            },
            ids: {
                ru: "biN-bDYWSVk",
                en: "bvV0WLLiIfs",
            },
        },
        {
            title: {
                ru: "Местные рецепты", // Укажи тему
                en: "Local recipes",
            },
            ids: {
                ru: "AWOVgwNZ53A", // Вставь YouTube ID русской версии
                en: "bUEUD8Is8mk", // Вставь YouTube ID английской версии
            },
        },
    ];

    const videoLang = lang === "ru" ? "ru" : "en";
    const activeVideo = videos[activeVideoIndex];
    const currentVideoId = activeVideo.ids[videoLang];

    const checkIfLoggedIn = () => {
        if (!user) {
            setShowModal(true)
        } else {
            if(user.uid === 'MVCEX1to21WF6TFd4IAQHhQjUvn1') {
                navigate('/admin')
            } else {
                navigate('/teacher')
            }
        }
    }

    useEffect(() => {
        // Собираем email динамически
        const user = "mail";
        const domain = "solar-spanish.com";
        setEmailForShow(`${user}@${domain}`);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        // console.log(email)
        // console.log(password)
        setError('')
        try {
            await signIn(email, password)
            if(email === 'homutnikov@mail.ru') {
                navigate('/admin')
            } else {
                navigate('/teacher')
            }
        } catch (e) {
            setErrorMessage('Los datos introducidos son incorrectos');
            setError(e.message)
            console.log(e.message)
        }
    }


    const iOSUrl = 'https://apps.apple.com/app/id6741136216';

    useEffect(() => {
        const savedLang = localStorage.getItem("lang");

        if (savedLang) {
            setLang(savedLang);
            return;
        }

        const userLang = navigator.language || navigator.userLanguage;

        if (userLang.startsWith("ru")) {
            setLang("ru");
        } else {
            setLang("en");
        }
    }, []);

    const videoIds = {
        ru: "biN-bDYWSVk", // ← вставь сюда id
        en: "bvV0WLLiIfs"
    };


    const translations = {
        en: {
            titleSection1: "An excellent tool for learning Spanish",
            subtitleSection1: "Whether you're studying Spanish with a teacher or not, this app will help you to learn and review words, practice verb conjugations, and train grammar with exercises",
            starSection1: "* Currently, only the Argentine variant of Spanish is available",
            wordsMemorizingSection2: "Words memorizing",
            subtitleSection2: "Thanks to the memory system and interval repetition of words, your vocabulary will grow quickly and effectively.",
            studyPlanSection2: "Study plan",
            plan1Section2: "Initial study of a set of words",
            plan2Section2: "Repetition 1 - one day after the first study session",
            plan3Section2: "Repetition 2 - two days after the last repetition",
            plan4Section2: "Repetition 3 - one week after the last repetition",
            plan5Section2: "Repetition 4 - one month after the last repetition",
            plan6Section2: "After 4 repetitions, words are moved to the list of learned words",
            wordscount1Section2: "words and phrases",
            wordscount2Section2: "in the app",
            exerciseOrderSection2: "Order of exercises",
            icons: [
                "Choice\nof words",
                "Words\nreview",
                "Translation\nchoice",
                "Match",
                "True or false",
                "Find the card",
                "Type"
            ],
            titleSection3: "Grammar exercises",
            subtitleSection3: "All exercises have been checked by qualified native-speaking teachers. We have also divided the tasks according to language proficiency levels.",
            audio1Section3: "Audio topics have two voice options: one for beginners and one that is more difficult for listening comprehension.",
            audio2Section3: "This helps you get used to the different ways native speakers talk.",
            howToUse: "How to use the app",
            shortVideo: "A short video on how to effectively learn words",
            grammar: "Grammar exercises",
        },
        ru: {
            titleSection1: "Отличный инструмент для изучения испанского",
            subtitleSection1: "Независимо от того, занимаешься ли ты испанским с преподавателем или самостоятельно, это приложение поможет тебе выучить и закрепить слова, попрактиковаться в спряжении глаголов и отработать грамматику с помощью упражнений",
            starSection1: "* В настоящее время доступен только аргентинский вариант испанского языка",
            wordsMemorizingSection2: "Запоминание слов",
            subtitleSection2: "Благодаря системе запоминания и интервальному повторению слов твой словарный запас будет быстро и эффективно пополняться.",
            studyPlanSection2: "План",
            plan1Section2: "Первоначальное изучение набора слов",
            plan2Section2: "Повторение 1 - через день после первого занятия",
            plan3Section2: "Повторение 2 - через два дня после последнего повтора",
            plan4Section2: "Повторение 3 - через неделю после последнего повтора",
            plan5Section2: "Повторение 4 - через месяц после последнего повтора",
            plan6Section2: "После 4 повторений слова перемещаются в список выученных слов",
            wordscount1Section2: "слов и выражений",
            wordscount2Section2: "в приложении",
            exerciseOrderSection2: "Порядок упражнений",
            icons: [
                "Выбор\nслов",
                "Ознакомление",
                "Выбор\nперевода",
                "Сопоставление",
                "Правда\nили ложь",
                "Найди\nкарточку",
                "Ввод\nслова"
            ],
            titleSection3: "Упражнения на грамматику",
            subtitleSection3: "Все упражнения проверены квалифицированными преподавателями-носителями языка. Кроме того, мы разделили задания в соответствии с уровнями владения языком.",
            audio1Section3: "В аудиозаписях предусмотрено два варианта озвучки: один для начинающих, а другой - более сложный, предназначенный для тренировки навыков аудирования.",
            audio2Section3: "Это поможет тебе привыкнуть к разным манерам речи носителей языка.",
            howToUse: "Как пользоваться",
            shortVideo: "Короткое видео о том, как эффективно учить слова",
            grammar: "Грамматические упражнения",
        }
    };

    const t = translations[lang];

    let icons = [
        { src: icon0, label: t.icons[0] },
        { src: icon1, label: t.icons[1] },
        { src: icon2, label: t.icons[2] },
        { src: icon3, label: t.icons[3] },
        { src: icon4, label: t.icons[4] },
        { src: icon5, label: t.icons[5] },
        { src: icon6, label: t.icons[6] },
    ];

    const iconsByLang = {
        en: {
            conjugate: "/images/conjugateIcon_eng.png",
            exercises: "/images/exercisesIcon_eng.png",
            repetitions: "/images/myRepetitionsIcon_eng.png",
            games: "/images/gamesIcon_eng.png",
        },
        ru: {
            conjugate: "/images/conjugateIcon_rus.png",
            exercises: "/images/exercisesIcon_rus.png",
            repetitions: "/images/myRepetitionsIcon_rus.png",
            games: "/images/gamesIcon_rus.png",
        }
    };

    const iconsLang = iconsByLang[lang] || iconsByLang.en;

    const easyAudio = "/audioExerciseExampleEasy.mp3";
    const hardAudio = "/audioExerciseExampleDifficult.mp3";

    const audioRef = useRef(null);

    const playAudio = (src) => {
        if (!src) {
            console.error("Audio src is missing");
            return;
        }

        if (audioRef.current) {
            audioRef.current.pause();
        }

        const audio = new Audio(src);
        audioRef.current = audio;
        audio.play().catch(err => console.error("Play error:", err));
    };

    return (
        <div className="relative bg-yellow-200">
            <div className="fixed top-0 left-0 w-full bg-white bg-opacity-50 backdrop-blur-md py-4 px-8 z-50">
                <div className="flex justify-between items-center">
                    <h1 className="text-2xl font-bold">Solar Spanish</h1>
                    <div className="flex items-center gap-2">

                        {/* Переключатель языка */}
                        <button
                            onClick={() => {
                                const newLang = lang === "ru" ? "en" : "ru";
                                setLang(newLang);
                                localStorage.setItem("lang", newLang);
                            }}
                            className="px-3 py-1 rounded-md bg-white text-black text-sm hover:bg-gray-200 transition"
                        >
                            {lang === "ru" ? "EN" : "RU"}
                        </button>

                        {/* Твоя кнопка */}
                        <button onClick={checkIfLoggedIn} className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-orange-200 to-yellow-200 group-hover:from-orange-200 group-hover:to-yellow-200 dark:text-white dark:hover:text-gray-900 focus:ring-4 focus:outline-none focus:ring-red-100 dark:focus:ring-red-400">
                            <span className="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                            Soy profesor
                            </span>
                        </button>

                    </div>
                </div>
            </div>

            <section className="
                relative 
                pt-6 md:pt-16
                h-auto md:h-screen
                overflow-hidden 
                flex flex-col md:flex-row 
                items-center justify-center
                bg-gradient-to-tr from-cyan-400 via-white-500 to-blue-500
            ">
                {/* Паттерн-фон с прозрачностью */}
                <div
                    className="absolute inset-0 opacity-20 bg-repeat"
                    style={{
                        backgroundImage: `url(${bgPattern})`
                    }}
                ></div>
                {/* Текст поверх */}
                <div className="mt-20 md:mt-0 relative z-10 text-center text-white drop-shadow-lg">
                    <h1 className="text-3xl md:text-6xl font-bold mb-4">{t.titleSection1}</h1>
                    <p className="text-lg md:text-2xl text-white/80 max-w-xl mx-auto mb-4 px-1">
                    {t.subtitleSection1}
                    </p>
                    <div className="flex items-center justify-center">
                        <a
                            href={iOSUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Download on the App Store"
                            className="block w-[160px] h-[55px] bg-contain bg-no-repeat hover:scale-105 transition"
                            style={{
                            backgroundImage:
                                "url('https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg')",
                            }}
                        />
                    </div>
                    <p className="text-lg text-white/80 max-w-xl mx-auto px-1">
                    {t.starSection1}
                    </p>
                </div>
                
                <div className="relative flex flex-col items-center justify-center pb-6">
                    <img
                        src="/images/screen_01.jpg"
                        alt="background"
                        className="mt-10 w-1/2 h-auto rounded-3xl border-4 border-solid border-black"
                    />
                {/* Задний слой — медленное плавание */}
                <motion.img
                    src={iconsLang.conjugate}
                    animate={{ x: [0, -20, 0], y: [0, -20, 0] }}
                    transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
                    className="absolute top-1/2 left-2/3 w-28 h-28 md:w-24 md:h-24 lg:w-28 lg:h-28 lg:w-32 lg:h-32 -translate-x-1/2 -translate-y-1/2 object-contain opacity-100 shadow-[0_0_25px_10px_rgba(0,0,0,0.4)] rounded-2xl"
                    alt="floating-icon"
                />

                {/* Средний слой — немного быстрее */}
                <motion.img
                    src={iconsLang.exercises}
                    animate={{ y: [0, -40, 0] }}
                    transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
                    className="absolute top-2/3 right-2/3 w-28 h-28 md:w-24 md:h-24 lg:w-28 lg:h-28 lg:w-32 lg:h-32 -translate-x-1/2 -translate-y-1/2 object-contain opacity-100 shadow-[0_0_25px_10px_rgba(0,0,0,0.4)] rounded-2xl"
                    alt="midground"
                />

                {/* Передний слой — самое заметное движение */}
                <motion.img
                    src={iconsLang.repetitions}
                    animate={{ x: [0, 20, 0], y: [0, 60, 0] }}
                    transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
                    className="absolute bottom-2/3 left-1/2 w-28 h-28 md:w-24 md:h-24 lg:w-28 lg:h-28 lg:w-32 lg:h-32 -translate-x-1/2 -translate-y-1/2 object-contain opacity-100 shadow-[0_0_25px_10px_rgba(0,0,0,0.4)] rounded-2xl"
                    alt="foreground"
                />

                {/* Задний слой — медленное плавание */}
                <motion.img
                    src={iconsLang.games}
                    animate={{ x: [0, 50, 0] }}
                    transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
                    className="absolute top-1/3 right-2/3 w-28 h-28 md:w-24 md:h-24 lg:w-28 lg:h-28 lg:w-32 lg:h-32 -translate-x-1/2 -translate-y-1/2 object-contain opacity-100 shadow-[0_0_25px_10px_rgba(0,0,0,0.4)] rounded-2xl"
                    alt="floating-icon"
                />


                {/* Градиент для читаемости */}
                {/* <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" /> */}
                </div>
                
            </section>

            <section className="
                relative 
                h-auto md:h-screen
                overflow-hidden 
                flex flex-col
                items-center justify-start 
                bg-gradient-to-br from-yellow-400 via-orange-500 to-red-500
            ">
                {/* Паттерн-фон с прозрачностью */}
                <div
                    className="absolute inset-0 opacity-20 bg-repeat"
                    style={{
                        backgroundImage: `url(${bgPattern})`
                    }}
                ></div>
                
                <div className="mt-5 relative z-10 text-center text-white drop-shadow-lg">
                    <h1 className="text-3xl md:text-6xl font-bold mb-4">{t.wordsMemorizingSection2}</h1>
                    <p className="text-lg text-white/80 max-w-xl mx-auto mb-4">
                    {t.subtitleSection2}
                    </p>
                </div>
                
                <div className='flex flex-col md:flex-row items-center justify-center w-full'>
                    <div className="text-black bg-white rounded-2xl p-2 m-2">
                        <p className='font-bold text-md'>{t.studyPlanSection2}</p>
                        <ul className="text-left">
                            <li>{t.plan1Section2}</li>
                            <li>{t.plan2Section2}</li>
                            <li>{t.plan3Section2}</li>
                            <li>{t.plan4Section2}</li>
                            <li>{t.plan5Section2}</li>
                            <li>{t.plan6Section2}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="
                        font-bold text-6xl text-center
                        bg-gradient-to-r from-pink-200 via-purple-200 to-blue-200
                        bg-clip-text text-transparent drop-shadow-md
                        ">3000</p>
                        <p className='text-center text-white'>{t.wordscount1Section2}</p>
                        <p className='text-center text-white'>{t.wordscount2Section2}</p>
                    </div>
                </div>
                
                <div className="p-4 text-white">
                    <p className='text-center mb-4 font-bold text-xl'>{t.exerciseOrderSection2}</p>
                    <ZigzagIcons icons={icons} />
                </div>

            </section>

            <section className="bg-gradient-to-br from-purple-500 to-indigo-600 px-5 py-10 md:py-14">
                <div className="mx-auto max-w-3xl">
                    <div className="text-center text-white">
                        <h2 className="text-2xl font-bold tracking-tight md:text-3xl">
                            {t.titleSection3}
                        </h2>

                        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/80 md:text-base">
                            {lang === "ru"
                                ? "Задания по уровням, проверенные преподавателями — носителями языка."
                                : "Exercises organized by level and reviewed by native-speaking teachers."}
                        </p>

                        <div className="mt-5 flex flex-wrap justify-center gap-2">
                            {["A1", "A2", "B1", "B2", "C1"].map((level) => (
                                <span
                                    key={level}
                                    className="rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-sm font-semibold"
                                >
                                    {level}
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="mt-8 rounded-2xl bg-white p-5 shadow-lg md:p-7">
                        <h3 className="text-lg font-semibold text-slate-900">
                            {lang === "ru"
                                ? "Тренируй понимание на слух"
                                : "Practice your listening"}
                        </h3>

                        <p className="mt-2 text-sm leading-relaxed text-slate-500">
                            {lang === "ru"
                                ? "Один текст, два варианта озвучки. Начни с медленного или попробуй обычный темп."
                                : "One text, two recordings. Start slow or try the regular pace."}
                        </p>

                        <blockquote className="my-5 border-l-2 border-indigo-200 pl-4 text-base leading-relaxed text-slate-700">
                            <p lang="es">
                                El verano pasado mis amigos y yo fuimos a la playa
                                para disfrutar del sol y del mar. Hacía un calor
                                agradable y la brisa marina refrescaba el ambiente.
                            </p>
                        </blockquote>

                        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                            <button
                                type="button"
                                onClick={() => playAudio(easyAudio)}
                                className="flex items-center justify-center gap-3 rounded-xl bg-indigo-600 px-4 py-3 text-sm font-medium text-white transition-colors hover:bg-indigo-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                <span aria-hidden="true">▶</span>
                                {lang === "ru"
                                    ? "Медленный темп"
                                    : "Slow pace"}
                            </button>

                            <button
                                type="button"
                                onClick={() => playAudio(hardAudio)}
                                className="flex items-center justify-center gap-3 rounded-xl bg-indigo-50 px-4 py-3 text-sm font-medium text-indigo-700 transition-colors hover:bg-indigo-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                <span aria-hidden="true">▶</span>
                                {lang === "ru"
                                    ? "Обычный темп"
                                    : "Regular pace"}
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-gradient-to-br from-blue-400 via-indigo-500 to-purple-600 px-5 py-10 md:py-12">
                <div className="mx-auto grid max-w-3xl items-center gap-6 md:grid-cols-[1fr_280px] md:gap-12">
                    <div className="text-white">
                        <h2 className="text-center text-2xl font-bold md:text-left md:text-3xl">
                            {videoLang === "ru"
                                ? "Как пользоваться"
                                : "How to use the app"}
                        </h2>

                        <p className="mt-3 text-center text-sm text-white/80 md:text-left md:text-base">
                            {videoLang === "ru"
                                ? "Короткие видео о возможностях приложения"
                                : "Short guides to the app"}
                        </p>

                        <div
                            className="mt-6 grid grid-cols-2 gap-2 md:grid-cols-1"
                            role="group"
                            aria-label={
                                videoLang === "ru"
                                    ? "Выбор видео"
                                    : "Choose a video"
                            }
                        >
                            {videos.map((video, index) => {
                                const isActive = activeVideoIndex === index;

                                return (
                                    <button
                                        key={index}
                                        type="button"
                                        aria-pressed={isActive}
                                        onClick={() => setActiveVideoIndex(index)}
                                        className={`flex items-center justify-between gap-3 rounded-xl px-4 py-3 text-left text-sm font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white ${
                                            isActive
                                                ? "bg-white text-indigo-700 shadow-sm"
                                                : "bg-white/10 text-white hover:bg-white/20"
                                        }`}
                                    >
                                        <span>{video.title[videoLang]}</span>
                                        <span aria-hidden="true" className="text-xs">
                                            ▶
                                        </span>
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    <div className="mx-auto aspect-[9/16] w-full max-w-[280px] overflow-hidden rounded-2xl bg-black/20 shadow-xl">
                        {currentVideoId ? (
                            <iframe
                                key={`${activeVideoIndex}-${videoLang}`}
                                className="h-full w-full border-0"
                                src={`https://www.youtube.com/embed/${currentVideoId}`}
                                title={activeVideo.title[videoLang]}
                                loading="lazy"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        ) : (
                            <div className="flex h-full items-center justify-center p-6 text-center text-sm text-white/80">
                                {videoLang === "ru"
                                    ? "Видео скоро появится"
                                    : "Video coming soon"}
                            </div>
                        )}
                    </div>
                </div>
            </section>
  
            {/* Footer */}
        <footer className="py-6 bg-black text-white flex flex-row justify-center items-center gap-4 flex-wrap">
            <a href={`mailto:${emailForShow}`} className="hover:underline">
                {emailForShow}
            </a>

            <span>|</span>

            <Link to="/privacy" className="hover:underline">
                Privacy Policy
            </Link>

            <span>|</span>

            <a
                href="https://t.me/solar_spanish"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center hover:opacity-80 transition"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-5 h-5 mr-1"
                >
                    <path d="M9.993 15.674l-.396 3.957c.568 0 .815-.244 1.11-.537l2.664-2.53 5.522 4.03c1.012.557 1.732.264 1.985-.938l3.598-16.87c.296-1.38-.499-1.92-1.487-1.56L1.32 9.38c-1.34.52-1.32 1.27-.228 1.61l5.965 1.86L19.69 4.91c.593-.39 1.132-.174.688.216"/>
                </svg>
                Telegram (rus)
            </a>

            <span>|</span>

            {/* INSTAGRAM */}
            <a
                href="https://instagram.com/solarspanish"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center hover:opacity-80 transition"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-5 h-5 mr-1"
                >
                    <path d="M7.75 2C4.678 2 2 4.678 2 7.75v8.5C2 19.322 4.678 22 7.75 22h8.5C19.322 22 22 19.322 22 16.25v-8.5C22 4.678 19.322 2 16.25 2h-8.5zm0 2h8.5C18.216 4 20 5.784 20 7.75v8.5c0 1.966-1.784 3.75-3.75 3.75h-8.5C5.784 20 4 18.216 4 16.25v-8.5C4 5.784 5.784 4 7.75 4zm8.75 1.5a1 1 0 100 2 1 1 0 000-2zM12 7a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6z"/>
                </svg>
                Instagram (eng)
            </a>
        </footer>

            {/* Модальное окно */}
            {showModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-8 rounded-md shadow-md sm:w-1/3">
                        <h3 className="text-sm text-center">Utilice la dirección de correo electrónico y la contraseña que le dieron</h3>
                        <h2 className="text-2xl font-bold mb-4">Login</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                            <label className="block text-sm font-medium mb-1" htmlFor="username">Email</label>
                            <input onChange={(e) => setEmail(e.target.value)} className="w-full border p-2 rounded-md" type="text" id="username" placeholder="Introduzca su email" />
                            </div>
                            <div className="mb-4">
                            <label className="block text-sm font-medium mb-1" htmlFor="password">Contraseña</label>
                            <input onChange={(e) => setPassword(e.target.value)} className="w-full border p-2 rounded-md" type="password" id="password" placeholder="Introduzca su contraseña" />
                            </div>
                            {errorMessage && <p className="text-red-500 text-sm">{errorMessage}</p>}
                            <div className="flex justify-end">
                            <button className="bg-blue-500 text-white px-4 py-2 rounded-md" type='submit'>
                                Login
                            </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
      </div>
    );
  }
  
  export default LandingPage;